<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="help">
      <g id="question">
        <path
          id="Stroke 1"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33 17.0003C33 25.8369 25.8361 33 17 33C8.16326 33 1 25.8369 1 17.0003C1 8.16376 8.16326 1 17 1C25.8361 1 33 8.16376 33 17.0003Z"
          stroke="white"
        />
        <g id="Group 4">
          <path
            id="Stroke 3"
            d="M11.4672 13.3127C11.4797 11.9106 12.0207 10.5119 13.0903 9.44228C15.2553 7.27735 18.7652 7.27696 20.9302 9.4419C23.0951 11.6068 23.0951 15.1172 20.9302 17.2821C19.8605 18.3518 18.4027 18.8924 17.0006 18.9048V22.5092"
            stroke="white"
          />
          <path id="Line 2" d="M17 24.5V26" stroke="white" stroke-linecap="square" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "34"
    },
    height: {
      type: String,
      default: "34"
    }
  }
};
</script>

<style lang="scss" scoped>
</style>